// --- START OF FILE BannerTrangChu.tsx ---
"use client"
import { ComponentConfig } from "@measured/puck"
import { Button, Modal } from "antd"
import { useState } from "react"
import { configs, DefaultImage, Media, MediaUpload } from "../../../../external-components"
import { BannerTrangChuProps, RenderConfig } from "./RenderConfig"

export const BannerTrangChu: ComponentConfig<BannerTrangChuProps> = {
  label: "Banner Trang Chủ",
  fields: {
    imageSrc: {
      label: "Image",
      type: "custom",
      render: (props: any) => {
        const [isModalOpen, setIsModalOpen] = useState(false)
        const [isChooseMedia, setIsChooseMedia] = useState(true)

        const handleSelectMedia = (media: { url: string }) => {
          props.onChange(media.url)
          setIsModalOpen(false)
        }

        const handleCloseModal = () => {
          setIsModalOpen(false)
        }

        return (
          <div>
            <img
              src={props.value ? `${configs.API_URL}${props.value}` : DefaultImage}
              alt="Preview"
              style={{ maxWidth: 200 }}
            />
            <button onClick={() => setIsModalOpen(true)}>Select Image</button>

            <Modal
              open={isModalOpen}
              title={<span className="ml-4">Select Media</span>}
              onCancel={handleCloseModal}
              style={{ top: 20 }}
              width="95%"
              footer={null}
            >
              <div className="ml-4 mt-5">
                <Button
                  onClick={() => setIsChooseMedia(true)}
                  className="mr-2"
                  style={{
                    backgroundColor: isChooseMedia ? "blue" : "initial",
                    color: isChooseMedia ? "white" : "initial",
                  }}
                >
                  Select Media
                </Button>
                <Button
                  onClick={() => setIsChooseMedia(false)}
                  style={{
                    backgroundColor: !isChooseMedia ? "blue" : "initial",
                    color: !isChooseMedia ? "white" : "initial",
                  }}
                >
                  Upload Media
                </Button>
              </div>
              <div>
                {isChooseMedia ? (
                  <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
                ) : (
                  <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
                )}
              </div>
            </Modal>
          </div>
        )
      },
    },
    imageMobile: {
      label: "Image Mobile",
      type: "custom",
      render: (props: any) => {
        const [isModalOpen, setIsModalOpen] = useState(false)
        const [isChooseMedia, setIsChooseMedia] = useState(true)

        const handleSelectMedia = (media: { url: string }) => {
          props.onChange(media.url)
          setIsModalOpen(false)
        }

        const handleCloseModal = () => {
          setIsModalOpen(false)
        }

        return (
          <div>
            <img
              src={props.value ? `${configs.API_URL}${props.value}` : DefaultImage}
              alt="Preview"
              style={{ maxWidth: 200 }}
            />
            <button onClick={() => setIsModalOpen(true)}>Select Image</button>

            <Modal
              open={isModalOpen}
              title={<span className="ml-4">Select Media</span>}
              onCancel={handleCloseModal}
              style={{ top: 20 }}
              width="95%"
              footer={null}
            >
              <div className="ml-4 mt-5">
                <Button
                  onClick={() => setIsChooseMedia(true)}
                  className="mr-2"
                  style={{
                    backgroundColor: isChooseMedia ? "blue" : "initial",
                    color: isChooseMedia ? "white" : "initial",
                  }}
                >
                  Select Media
                </Button>
                <Button
                  onClick={() => setIsChooseMedia(false)}
                  style={{
                    backgroundColor: !isChooseMedia ? "blue" : "initial",
                    color: !isChooseMedia ? "white" : "initial",
                  }}
                >
                  Upload Media
                </Button>
              </div>
              <div>
                {isChooseMedia ? (
                  <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
                ) : (
                  <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
                )}
              </div>
            </Modal>
          </div>
        )
      },
    },
    heading1: {
      label: "Heading 1",
      type: "text",
    },
    heading2: {
      label: "Heading 2",
      type: "text",
    },
    inputValue: {
      label: "Input Value",
      type: "text",
    },
  },
  defaultProps: {
    imageSrc: "",
    heading1: "Default Heading 1",
    heading2: "Default Heading 2",
    inputValue: "",
  },
  ...RenderConfig,
}
